<app-drawing-on-image #drawingOnImageComponent
        *ngIf="initDone"
        [imageUrl]="imageUrl"
        [options]="options"
        [drawingData]="drawingData"
        (changedEvent)="changed($event)">
</app-drawing-on-image>
